import React, { useRef } from 'react'
import { Row, Col, Form, Select } from 'antd'
import { DataItem } from '@gravitate-js/excalibrr'
import { FormInput } from '../../../../../_SiteWide/Form/FormInput'
import { ManifoldSelect } from '@components/Admin/Tank/Grid/Detail/TankSizing/ManifoldSelect'
import { TankManifoldDisplay } from './TankManifoldDisplay'
const { Option } = Select

export const TankDetailsForm = ({ tank, metadata, editing, availableManifolds }) => {
  const tankChart = tank.tank_chart || tank.tank_chartEdit || 'No Tank Chart'
  const wrapperRef = useRef(null)
  return (
    <div className='flex-2 p-3 tank-sizing-details'>
      <b className='store-detail-header'>Tank Details</b>
      <Row className='tank-chart-data'>
        <Col span={12} className='pb-3 pt-4'>
          {editing ? (
            <div ref={wrapperRef}>
              <DataItem label='Tank Chart'>
                <Form.Item name='tank_chart'>
                  <Select
                    getPopupContainer={(_) => wrapperRef?.current}
                    allowClear
                    name='tank_chart'
                    placeholder='Search by Tank Chart'
                    showSearch
                    style={{ width: '100%' }}
                  >
                    {metadata?.tank_charts?.map((chart, i) => (
                      <Option key={i} value={chart}>
                        {chart}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </DataItem>
            </div>
          ) : (
            <b className='text-size-8'>{tankChart}</b>
          )}
        </Col>
      </Row>
      <Row className='pt-3'>
        <Col span={8}>
          <DataItem label='Manufacturer'>
            <FormInput
              name='manufacturer'
              placeholder='Manufacturer'
              width='90%'
              editable={editing}
              initialValue={tank.manufacturer ? tank.manufacturer : 'Not Listed'}
            />
          </DataItem>
        </Col>
        <Col span={8}>
          <DataItem label='Dimensions'>
            <FormInput
              name='dimensions'
              placeholder='Dimensions'
              width='90%'
              editable={editing}
              initialValue={tank.dimensions ? tank.dimensions : 'Not Defined'}
            />
          </DataItem>
        </Col>
        <Col span={8}>
          <DataItem label='Tank Color'>
            <FormInput
              name='tank_color'
              placeholder='Tank Color'
              width='90%'
              editable={editing}
              initialValue={tank.tank_color ? tank.tank_color : 'Not Defined'}
            />
          </DataItem>
        </Col>
      </Row>
      <Row>
        <Col span={24} className='pb-2'>
          <DataItem label='Tank Manifold'>
            {editing ? (
              <ManifoldSelect name='manifold_id' availableManifolds={availableManifolds} tank={tank} />
            ) : (
              <TankManifoldDisplay tank={tank} />
            )}
          </DataItem>
        </Col>
      </Row>
    </div>
  )
}
